// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/start_project_credit_pack_purchase.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/start_project_credit_pack_purchase.proto.
 */
export const file_vision_billing_v1_start_project_credit_pack_purchase: GenFile = /*@__PURE__*/
  fileDesc("Cjp2aXNpb24vYmlsbGluZy92MS9zdGFydF9wcm9qZWN0X2NyZWRpdF9wYWNrX3B1cmNoYXNlLnByb3RvEhhwcm90b3MudmlzaW9uLmJpbGxpbmcudjEirwEKJVN0YXJ0UHJvamVjdENyZWRpdFBhY2tQdXJjaGFzZVJlcXVlc3QSVgoGcGFyYW1zGAEgASgLMkYucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlN0YXJ0UHJvamVjdENyZWRpdFBhY2tQdXJjaGFzZVJlcXVlc3QuUGFyYW1zGi4KBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEhAKCHBhY2tfa2V5GAIgASgJIrUBCiZTdGFydFByb2plY3RDcmVkaXRQYWNrUHVyY2hhc2VSZXNwb25zZRJXCgZyZXN1bHQYASABKAsyRy5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuU3RhcnRQcm9qZWN0Q3JlZGl0UGFja1B1cmNoYXNlUmVzcG9uc2UuUmVzdWx0GjIKBlJlc3VsdBIUCgxjaGVja291dF91cmwYASABKAkSEgoKc2Vzc2lvbl9pZBgCIAEoCWIGcHJvdG8z");

/**
 * @generated from message protos.vision.billing.v1.StartProjectCreditPackPurchaseRequest
 */
export type StartProjectCreditPackPurchaseRequest = Message<"protos.vision.billing.v1.StartProjectCreditPackPurchaseRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.StartProjectCreditPackPurchaseRequest.Params params = 1;
   */
  params?: StartProjectCreditPackPurchaseRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.StartProjectCreditPackPurchaseRequest.
 * Use `create(StartProjectCreditPackPurchaseRequestSchema)` to create a new message.
 */
export const StartProjectCreditPackPurchaseRequestSchema: GenMessage<StartProjectCreditPackPurchaseRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_project_credit_pack_purchase, 0);

/**
 * @generated from message protos.vision.billing.v1.StartProjectCreditPackPurchaseRequest.Params
 */
export type StartProjectCreditPackPurchaseRequest_Params = Message<"protos.vision.billing.v1.StartProjectCreditPackPurchaseRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string pack_key = 2;
   */
  packKey: string;
};

/**
 * Describes the message protos.vision.billing.v1.StartProjectCreditPackPurchaseRequest.Params.
 * Use `create(StartProjectCreditPackPurchaseRequest_ParamsSchema)` to create a new message.
 */
export const StartProjectCreditPackPurchaseRequest_ParamsSchema: GenMessage<StartProjectCreditPackPurchaseRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_project_credit_pack_purchase, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.StartProjectCreditPackPurchaseResponse
 */
export type StartProjectCreditPackPurchaseResponse = Message<"protos.vision.billing.v1.StartProjectCreditPackPurchaseResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.StartProjectCreditPackPurchaseResponse.Result result = 1;
   */
  result?: StartProjectCreditPackPurchaseResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.StartProjectCreditPackPurchaseResponse.
 * Use `create(StartProjectCreditPackPurchaseResponseSchema)` to create a new message.
 */
export const StartProjectCreditPackPurchaseResponseSchema: GenMessage<StartProjectCreditPackPurchaseResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_project_credit_pack_purchase, 1);

/**
 * @generated from message protos.vision.billing.v1.StartProjectCreditPackPurchaseResponse.Result
 */
export type StartProjectCreditPackPurchaseResponse_Result = Message<"protos.vision.billing.v1.StartProjectCreditPackPurchaseResponse.Result"> & {
  /**
   * @generated from field: string checkout_url = 1;
   */
  checkoutUrl: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message protos.vision.billing.v1.StartProjectCreditPackPurchaseResponse.Result.
 * Use `create(StartProjectCreditPackPurchaseResponse_ResultSchema)` to create a new message.
 */
export const StartProjectCreditPackPurchaseResponse_ResultSchema: GenMessage<StartProjectCreditPackPurchaseResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_project_credit_pack_purchase, 1, 0);

